import React, { useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { Modal } from 'antd';
import { toast } from 'react-toastify';

const EditTauxCommissionContrat = ({ editTauxCommissionOpenModal, setEditTauxCommissionOpenModal, selectedContrat, editedTauxCommission, setEditedTauxCommission }) => {
    const [loading, setLoading] = useState(false);

    const onSubmitEditTauxCommission = (e) => {
        e.preventDefault();

        setLoading(true);
        axiosInstance
            .get(`/api/contrat/update-taux-commission/${selectedContrat.codeId}/${editedTauxCommission}`)
            .then((res) => {
                console.log(res.data);
                setLoading(false);
                toast("Taux de commission redéfini avec succès!");
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }

    return (
        <Modal open={editTauxCommissionOpenModal} loading={loading} onOk={onSubmitEditTauxCommission} onCancel={() => setEditTauxCommissionOpenModal(false)} zIndex={1900} centered>
            <div className="text-center mb-6">
                <h4 className="address-title mb-2">Taux de commission </h4>
                <p className="address-subtitle">
                    Recaclculer le taux de commission pour le contrat <b>{selectedContrat?.numeroPoliceP}</b>
                </p>
            </div>
            <form id="addNewAddressForm" className="row g-12" onSubmit={onSubmitEditTauxCommission}>
                <div className="col-12 col-md-12">
                    <div className="row">
                        <div className="col-md-12 select2-primary">
                            <label className="form-label" htmlFor="tauxCommission">
                                Veuillez entre la valeur du taux de commission à considérer
                            </label>
                            <input className="form-control" id="tauxCommission" name="tauxCommission" value={editedTauxCommission}
                                onChange={(e) => {
                                    setEditedTauxCommission(parseFloat(e.target.value));
                                }}
                                placeholder="Entrez le taux de commission en %" type="number"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default EditTauxCommissionContrat